import "./VisionAndMission.css"
import { useInView } from "framer-motion";
import { useRef } from "react";
import { motion } from "framer-motion";

const VisionAndMission = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1, ease: "easeOut" }}
            className="vm-container"
        >
            <div className="vm-overlay">
                
                <motion.div
                    className="vm-card"
                    initial={{ opacity: 0, x: -40 }}
                    animate={isInView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <div className="vm-title-block">
                        <span className="vm-label">01</span>
                        <h2 className="vm-title">Vizyonumuz</h2>
                        <div className="vm-line" />
                    </div>
                    <p className="vm-text">
                        İnşaat sektöründe sağlam adımlarla basamakları tırmanarak, çalışanlarımız ile birlikte büyüyerek,
                        ulusal ve uluslararası köklü firmalar arasında bayrağımızı zirvede dalgalandırarak ülkemizin bir değeri olmak.
                    </p>
                </motion.div>

                <div className="vm-divider" />

                {/* MİSYON */}
                <motion.div
                    className="vm-card"
                    initial={{ opacity: 0, x: 40 }}
                    animate={isInView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.8, delay: 0.4 }}
                >
                    <div className="vm-title-block">
                        <span className="vm-label">02</span>
                        <h2 className="vm-title">Misyonumuz</h2>
                        <div className="vm-line" />
                    </div>
                    <p className="vm-text">
                        Doğal afetlere dayanıklı, minimum maliyet ile maksimum kalite seviyesine ulaşmış
                        mühendislik yapıları oluşturmak, müşteri memnuniyeti doğrultusunda verilen taahhütlerin
                        kaliteden ödün vermeksizin zamanında yerine getirmek.
                    </p>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default VisionAndMission;